"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    {
        anonymous: false,
        inputs: [
            { indexed: false, internalType: "uint8", name: "version", type: "uint8" },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "pairManager",
                type: "address",
            },
        ],
        name: "PairManagerCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        inputs: [
            { internalType: "address", name: "_address", type: "address" },
            { internalType: "bool", name: "allow", type: "bool" },
        ],
        name: "addAllowedAddress",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_pairManager", type: "address" },
            { internalType: "address", name: "_baseAsset", type: "address" },
            { internalType: "address", name: "_quoteAsset", type: "address" },
        ],
        name: "addPairManagerManual",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "", type: "address" }],
        name: "allowedAddressAddPair",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_quoteAsset", type: "address" },
            { internalType: "address", name: "_baseAsset", type: "address" },
            { internalType: "uint256", name: "_basisPoint", type: "uint256" },
            { internalType: "uint256", name: "_BASE_BASIC_POINT", type: "uint256" },
            {
                internalType: "uint128",
                name: "_maxFindingWordsIndex",
                type: "uint128",
            },
            { internalType: "uint128", name: "_initialPip", type: "uint128" },
            { internalType: "uint64", name: "_expireTime", type: "uint64" },
        ],
        name: "createPairManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "pairManager", type: "address" }],
        name: "delPairManager",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "quoteAsset", type: "address" },
            { internalType: "address", name: "baseAsset", type: "address" },
        ],
        name: "getPairManager",
        outputs: [
            { internalType: "address", name: "spotManager", type: "address" },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "tokenA", type: "address" },
            { internalType: "address", name: "tokenB", type: "address" },
        ],
        name: "getPairManagerSupported",
        outputs: [
            { internalType: "address", name: "baseToken", type: "address" },
            { internalType: "address", name: "quoteToken", type: "address" },
            { internalType: "address", name: "pairManager", type: "address" },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "pairManager", type: "address" }],
        name: "getQuoteAndBase",
        outputs: [
            {
                components: [
                    { internalType: "address", name: "BaseAsset", type: "address" },
                    { internalType: "address", name: "QuoteAsset", type: "address" },
                ],
                internalType: "struct SpotFactoryStorage.Pair",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "_spotHouse", type: "address" }],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "pairManager", type: "address" }],
        name: "isPairManagerExist",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "liquidityPool",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [{ internalType: "bool", name: "", type: "bool" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "_liquidityPool", type: "address" },
        ],
        name: "setLiquidityPool",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "address", name: "newSpotHouse", type: "address" },
        ],
        name: "setSpotHouse",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "spotHouse",
        outputs: [{ internalType: "address", name: "", type: "address" }],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [{ internalType: "address", name: "newOwner", type: "address" }],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
//# sourceMappingURL=peFactory.js.map